import * as yup from 'yup';
import { IName, NameSchema } from './IName';

export const UserSchema = yup.object({
  name: NameSchema.notRequired(),
  username: yup.string().required(),
  password: yup.string().required(),
  passwordGenerated: yup.bool().required(),
  globalAdmin: yup.bool().default(false),
  roleId: yup.string().required(),
  additionalRights: yup.array(yup.string().required()).default([]),
});

export interface IUser {
  name?: IName;
  username: string;
  password: string;
  passwordGenerated: boolean;
  globalAdmin?: boolean;
  roleId: string;
  additionalRights: string[];
}
